// getApplePayPrimeWithTappay.js
'use strict';
import loadTappayScript from '../resource/loadTappayScript.js';
import getDecimalFactorByCurrency from '../resource/getDecimalFactorByCurrency.js';

const supportedNetworks = [
  'AMEX',
  'MASTERCARD',
  'VISA',
  'JCB',
  'CHINAUNIONPAY',
  'DISCOVER',
  'INTERAC',
];

const setupPaymentRequest = ({ paymentRequest }) =>
  new Promise(resolve => {
    window.TPDirect.paymentRequestApi.setupPaymentRequest(
      paymentRequest,
      result => {
        if (!result.browserSupportPaymentRequest) {
          return resolve({
            status: 'fail',
            payload: {
              message: 'Browser not support Apple Pay.',
            },
          });
        }
        return resolve({
          status: 'success',
          payload: {
            canMakePaymentWithActiveCard: result.canMakePaymentWithActiveCard,
          },
        });
      }
    );
  });

export const setupApplePayWithTappay = async ({
  totalValue,
  currency,
  items,
  tappayApplePayId,
}) => {
  const decimalFactor = getDecimalFactorByCurrency({ currency });
  const paymentRequest = {
    supportedNetworks,
    supportedMethods: ['apple_pay'],
    displayItems: items.map(item => ({
      label: item.description,
      amount: {
        currency: currency.toUpperCase(),
        value: `${item.amount / decimalFactor}`,
      },
    })),
    total: {
      label: 'SWAG Diamond Shop',
      amount: {
        currency: currency.toUpperCase(),
        value: `${totalValue / decimalFactor}`,
      },
    },
  };

  if (!window.TPDirect) {
    await loadTappayScript();
  }

  window.TPDirect.paymentRequestApi.setupApplePay({
    merchantIdentifier: tappayApplePayId,
    countryCode: 'TW',
  });

  return setupPaymentRequest({ paymentRequest });
};

const getApplePayPrimeWithTappay = () =>
  new Promise(resolve => {
    window.TPDirect.paymentRequestApi.getPrime(result => {
      if (0 !== result.status) {
        return resolve({ status: 'fail', payload: { message: result.msg } });
      }
      return resolve({ status: 'success', payload: { prime: result.prime } });
    });
  });

export default getApplePayPrimeWithTappay;
